<template>
  <van-sticky
    :style="{
      opacity: needSticky ? Number(showSelection) : 1,
      pointerEvents: needSticky ? (Number(showSelection) ? 'auto' : 'none') : 'auto',
      marginTop: needSticky ? '-42px' : 0
    }"
    :offset-top="((navigationHeight * 1) + (noticeHeight * 1) + 42)"
    @change="onSticky"
  >
    <ObSelection
      v-model="sortType"
      :options="options || defaultOptions"
      :fitWidth="true"
      :showOverlay="showLayer"
      @select="switchType"
    />
  </van-sticky>
  
  <ObList
    ref="obListRef"
    :load="getList"
    @refresh="refresh"
  >
    <component 
      v-for="(item, index) in list"
      :key="item.id"
      :is="item.components" 
      :cardInfo="item"
      :showTag="!!item?.circleInfo?.id"
      :index="index"
      :showStick="Boolean(item.stick)"
    />
  </ObList>
</template>

<script setup>
import { $throttle } from '@/utils/lodashFuncs'

import { storeToRefs } from 'pinia'
import { useNavigationStore } from '@/stores/navigation'

const emits = defineEmits(['changeSort'])
const props = defineProps({
  categoryId: {
    type: String,
  },
  options: {
    type: Array,
    default: null
  },
  apiName: {
    type: String
  },
  needSticky: {
    type: Boolean,
    default: false
  }
})

const navigationStore = useNavigationStore()  // 用户仓库
const { proxy } = getCurrentInstance()
const { navigationHeight, noticeHeight } = storeToRefs(navigationStore)   // 用户id

const obListRef = ref(null)

const sortType = ref(props.options ? 1 : 2)
const showLayer = ref(false)
const showSelection = ref(false)

const list = ref([])

const defaultOptions = ref([{
  label: proxy.$t('latestCreated'),
  value: 2
},{
  label: proxy.$t('latestActivity'),
  value: 3
}])

function onSticky (val) {
  if (props.needSticky) {
    showSelection.value = val
  } else {}
  showLayer.value = val
}

function refresh (val) {
  list.value = []
  nextTick(() => {
    obListRef.value.onRefresh(val)
  })
}

async function switchType (val) {
  emits('changeSort', val)
  refresh()
}

async function getList (params) {
  const { pageData = {
    page: 1,
    limit: 20,
  }} = params || {}
  const queryParams = {
    ...pageData,
    type: sortType.value,
  }
  if (props.categoryId) {
    queryParams.categoryId = props.categoryId
  }
  const { code, data, msg} = await proxy.$http[props.apiName](queryParams)
  let finished = false
  if (code === 200 && data) {
    const { rows, total } = data || {}
    for(const i of rows) {
      switch (i.type) {
        case 1:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/articleCard.vue')))
          break
        case 2:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/momentCard.vue')))
          break
        case 4:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/pollCard.vue')))
          break
        default:
      }
    }
    list.value = [...list.value, ...rows]
    finished = list.value.length >= total || !rows?.length
  }
  return {
    code,
    finished
  }
}



</script>

<style lang="postcss" scoped>
:deep(.van-sticky) {
  .ob-selection {
    width: 100vw;
  }
}
.selection-block {
  width: 100%;
  position: fixed;
  z-index: 100;
  :deep(.ob-selection) {
    width: 100vw;
  }
}
</style>